export default "__VITE_ASSET__DKFsBAFK__"